import { Span } from '@bpba/ui-components';
import {
  textAlign,
  TextAlignProps,
  lineHeight,
  LineHeightProps,
  border,
  BorderProps,
  compose,
  JustifyContentProps,
  justifyContent,
} from 'styled-system';
import styled from 'styled-components';

export const StyledSpan = styled(Span)<TextAlignProps & JustifyContentProps & LineHeightProps & BorderProps>(
  compose(textAlign, justifyContent, lineHeight, border)
);
